import React, { FC } from 'react';

import { ContextMenuRow } from './ContextMenuRow';

export const ContextMenuSeparator: FC = () => (
  <ContextMenuRow>
    <div className="c-edit__line"></div>
  </ContextMenuRow>
);
